var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLoading)?_vm._t("loader",function(){return [_c('div',{staticClass:"o-loader"},[_vm._v(_vm._s(_vm.$t('loading')))])]}):_vm._e(),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLoading),expression:"!isLoading"}]},[_vm._t("default")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }